import { Pipe, PipeTransform } from '@angular/core';

import {DataSourceType, DataSourceTypeTitleMap} from '../../views/admin/application-settings/models/data-source-type.model';
import {CustomerService} from '@app/core/service/customer.service';

@Pipe({
    name: 'ngcDataSourceTypeTitle'
})
export class DataSourceTypeTitlePipe implements PipeTransform {

    transform(dataSourceType: string): string {
        // Ugly hack for Amplify
        let result = DataSourceTypeTitleMap.get(<DataSourceType>dataSourceType);
        if (CustomerService.checkIsAmplifyCustomer() && (result === 'SFTP')) {
            result = 'ORCSV';
        }
        return result;
    }
}


